import { FeatureTokenAvailability, FeatureTokenType } from 'src/api/monetisation/types';
import { CompactUser } from 'src/context/user';
import { ExperienceType } from 'src/context/experience';
import { Buddy } from 'src/api/buddy/types';

export const toBuddyTokenType = (buddyId: string): FeatureTokenType =>
  `buddy_type_${buddyId.replaceAll('-', '_')}`;

export const isBuddyLocked = (
  user: CompactUser | null | undefined,
  experienceType: ExperienceType | null | undefined,
  buddy: Buddy | null | undefined,
  availabilityData: FeatureTokenAvailability[] | null | undefined,
): boolean => {
  if (!buddy || !experienceType || !user || user.isPro) return false;

  if (experienceType === '2024') {
    return buddy.isPremium;
  }

  if (!availabilityData) return false;

  const tokenType = toBuddyTokenType(buddy.id);
  return availabilityData.some(f => f.type === tokenType && !f.available);
};
